/**
 * ResizeHandle Component
 * 
 * A visual handle for resizing table columns with hover and active states.
 * Supports both drag-to-resize and double-click-to-auto-fit.
 * 
 * @example
 * ```tsx
 * <ResizeHandle
 *   onMouseDown={(e) => handleMouseDown(e, 'columnKey')}
 *   onDoubleClick={(e) => handleDoubleClick(e, 'columnKey')}
 * />
 * ```
 */

import { cn } from '../lib/utils';

interface ResizeHandleProps {
  onMouseDown: (e: React.MouseEvent) => void;
  onDoubleClick: (e: React.MouseEvent) => void;
  className?: string;
}

export function ResizeHandle({ onMouseDown, onDoubleClick, className }: ResizeHandleProps) {
  return (
    <div
      className={cn(
        'absolute right-0 top-0 h-full w-1 cursor-col-resize select-none',
        'hover:bg-primary/50 active:bg-primary',
        'transition-colors duration-150',
        'group-hover:bg-border',
        className
      )}
      onMouseDown={onMouseDown}
      onDoubleClick={onDoubleClick}
      title="Drag to resize, double-click to auto-fit"
    >
      {/* Wider hit area for easier interaction */}
      <div className="absolute inset-y-0 -left-2 -right-2" />
    </div>
  );
}
